import {
  actionsForActionType,
  PromoterAction,
} from "~features/competitions/helpers";
import { useActiveCompetitionByType } from "~features/events/hooks/useActiveCompetitions";
import { GetPromoterSettingsDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";

export const useSocialLinkOptions = ({
  eventId,
  activeCompetition,
}: {
  eventId: string;
  activeCompetition?: ReturnType<
    typeof useActiveCompetitionByType
  >["activeCompetition"];
}) => {
  const { data: promoterSettings } = useQuery(
    eventId && GetPromoterSettingsDocument,
    {
      eventId,
    }
  );

  const competitionPromoter = activeCompetition?.promoter?.filter(
    (p) => !!p.isEnabled
  );

  const promoterData =
    competitionPromoter ??
    promoterSettings?.getPromoterSettings?.configurations;

  const shareOptions =
    promoterData &&
    actionsForActionType(promoterData, false, ...["share", "invite"]);

  const socialOptions =
    promoterData &&
    actionsForActionType(promoterData, true, ...["share", "invite"])?.reduce(
      (acc, item) => {
        const socialUrl = promoterSettings?.getPromoterSettings?.socialPages?.find(
          (sp) => sp.name === item.socialLinkType && sp.isEnabled
        )?.url;

        if (!socialUrl) return acc;

        acc.push({
          ...item,
          socialUrl,
        });

        return acc;
      },
      [] as PromoterAction[]
    );

  return [...(shareOptions ?? []), ...(socialOptions ?? [])];
};
